/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Cards_DescInputs */

const en_mk_team_cards_desc = /** @type {(inputs: Mk_Team_Cards_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When there is a choice of direction, such as a merge conflict or a Reviewer finding, you see the options and what each one leads to. Your choice is recorded and used by agents on the next task.`)
};

const id_mk_team_cards_desc = /** @type {(inputs: Mk_Team_Cards_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat ada pilihan arah, misalnya bentrok saat menggabung atau temuan Pemeriksa, kamu melihat pilihan beserta akibatnya. Pilihanmu dicatat dan dipakai agent pada tugas berikutnya.`)
};

/**
* | output |
* | --- |
* | "When there is a choice of direction, such as a merge conflict or a Reviewer finding, you see the options and what each one leads to. Your choice is recorded ..." |
*
* @param {Mk_Team_Cards_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_cards_desc = /** @type {((inputs?: Mk_Team_Cards_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Cards_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_cards_desc(inputs)
	return en_mk_team_cards_desc(inputs)
});